import { DialogType } from '../../../common/enums.js';
import { useAuth } from '../../../public/site/AuthProvider';
import { useDialog } from '../../../public/site/DialogProvider.js';
import { closeDialog } from '../../../public/site/dialogStore.js';
import { DialogWrapper } from '../../DialogWrapper/index.js';

export const PunchoutDialog = () => {
  const { validateAuth } = useAuth();
  const dialog = useDialog();
  const onCloseDialog = () => closeDialog();

  if (dialog?.params?.type) {
    switch (dialog.params.type) {
      case DialogType.DUPLICATE_CONTACT:
        return (
          <DialogWrapper
            buttons={[
              {
                onClick: () => {
                  onCloseDialog();
                  validateAuth();
                },
                text: 'OK',
              },
            ]}
            onCloseDialog={onCloseDialog}
            header={dialog.params.header}
          >
            <p>{dialog.params.body}</p>
          </DialogWrapper>
        );
    }
  }
  return null;
};
